/* Ripple Rewards / Referral page behaviour.
   Talks to the Ripple app proxy, fills the referral panel, the balance chips
   and the milestone ladder. Markup lives in sections/rrp-*.liquid; the logged-in
   flag and proxy path are read off [data-rrp-root] in sections/rrp-hero.liquid. */
/* Scroll reveals. Purely additive: the CSS that hides these elements only
   applies while <html> carries .rrp-anim, which the inline script in
   sections/rrp-hero.liquid adds during parse and only when the visitor has not
   asked for reduced motion. If this file never runs, nothing is ever hidden. */
(function () {
  'use strict';

  /* Tells the inline watchdog in rrp-hero.liquid that this file arrived, so it
     leaves the .rrp-anim gate in place. Set before anything can return early. */
  window.rrpMotionReady = true;

  if (!document.documentElement.classList.contains('rrp-anim')) return;

  var targets = [].slice.call(
    document.querySelectorAll('[data-rrp-reveal],[data-rrp-stagger],[data-rrp-track]')
  );
  if (!targets.length) return;

  var revealed = 0;
  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    revealed++;
  }

  if (!('IntersectionObserver' in window)) {
    targets.forEach(reveal);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -6% 0px' }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });

  /* Failsafe: if the observer never fires at all, show everything rather than
     leaving the page blank. Only trips when nothing has been revealed. */
  setTimeout(function () {
    if (!revealed) targets.forEach(reveal);
  }, 3000);
})();

(function () {
  'use strict';

  var root = document.querySelector('[data-rrp-root]');
  if (!root) return;

  var PROXY = root.getAttribute('data-rrp-proxy') || '/apps/ripple';
  var loggedIn = root.getAttribute('data-rrp-logged-in') === 'true';

  function $(sel) {
    return document.querySelector(sel);
  }

  function toast(msg) {
    var el = $('.rrp-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rrp-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    setTimeout(function () {
      el.classList.remove('is-on');
    }, 2200);
  }

  function fallbackCopy(input) {
    if (!input) return;
    input.focus();
    input.select();
    try {
      document.execCommand('copy');
      toast('Link copied');
    } catch (e) {
      /* leave selected */
    }
  }

  function copyText(text, input) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        function () {
          toast('Link copied');
        },
        function () {
          fallbackCopy(input);
        }
      );
    } else {
      fallbackCopy(input);
    }
  }

  /* Count-up animation for personal numbers. */
  function countUp(el, target) {
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (document.hidden || reduce) {
      el.textContent = target;
      return;
    }
    var start = null;
    var dur = 900;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
  }

  function renderMember(member) {
    var box = $('[data-rrp-member-box]');
    if (box) box.hidden = false;

    var linkInput = $('[data-rrp-link]');
    if (linkInput) linkInput.value = member.link;

    var copyBtn = $('[data-rrp-copy]');
    if (copyBtn)
      copyBtn.addEventListener('click', function () {
        copyText(member.link, linkInput);
      });

    var shareBtn = $('[data-rrp-share]');
    if (shareBtn && navigator.share) {
      shareBtn.hidden = false;
      shareBtn.addEventListener('click', function () {
        navigator
          .share({ title: '20% off + a free bottle at Neurogan Health', url: member.link })
          .catch(function () {});
      });
    }

    var chip = $('[data-rrp-count-chip]');
    var completed = member.ladder ? member.ladder.completed : 0;
    if (chip) chip.textContent = completed + (completed === 1 ? ' friend referred' : ' friends referred');

    var avail = $('[data-rrp-available]');
    if (avail) avail.textContent = money(member.storeCredit.payableCents) + ' available';

    var pend = $('[data-rrp-pending]');
    if (pend && member.storeCredit.pendingCents > 0) {
      pend.textContent = money(member.storeCredit.pendingCents) + ' pending';
    }

    /* Ladder progress track */
    var maxAt = 8;
    if (member.ladder && member.ladder.milestones.length) {
      maxAt = member.ladder.milestones[member.ladder.milestones.length - 1].at;
    }
    var pct = Math.min(completed / maxAt, 1) * 100;

    var fill = $('[data-rrp-fill]');
    if (fill) fill.style.width = pct + '%';

    var marker = $('[data-rrp-marker]');
    if (marker) {
      marker.hidden = false;
      marker.style.left = pct + '%';
      var num = marker.querySelector('[data-rrp-marker-count]');
      if (num) countUp(num, completed);
    }

    var next = $('[data-rrp-next]');
    if (next && member.ladder) {
      var upcoming = null;
      for (var i = 0; i < member.ladder.milestones.length; i++) {
        if (!member.ladder.milestones[i].unlocked && member.ladder.milestones[i].at > completed) {
          upcoming = member.ladder.milestones[i];
          break;
        }
      }
      next.textContent = upcoming
        ? (upcoming.at - completed) +
          ' more referral' +
          (upcoming.at - completed === 1 ? '' : 's') +
          ' unlocks: ' +
          upcoming.label
        : 'Ladder complete — you did it all.';
    }

    if (member.ladder) {
      member.ladder.milestones.forEach(function (m) {
        var node = $('[data-rrp-node="' + m.at + '"]');
        if (node && m.unlocked) node.classList.add('is-unlocked');
      });
    }

    /* Share module link mirror */
    var link2 = $('[data-rrp-link2]');
    if (link2) link2.value = member.link;

    var copy2 = $('[data-rrp-copy2]');
    if (copy2)
      copy2.addEventListener('click', function () {
        copyText(member.link, link2);
      });

    var memberShare = $('[data-rrp-share-member]');
    var guestShare = $('[data-rrp-share-guest]');
    if (memberShare) memberShare.hidden = false;
    if (guestShare) guestShare.hidden = true;
  }

  function bindApply(applyBox) {
    var applyBtn = $('[data-rrp-apply]');
    if (!applyBtn) return;
    applyBtn.addEventListener('click', function () {
      applyBtn.disabled = true;
      applyBtn.textContent = 'Activating…';
      var form = new FormData();
      form.append('intent', 'apply');
      fetch(PROXY + '/panel', { method: 'POST', body: form })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (!res.ok) throw new Error('apply_failed');
          return fetch(PROXY + '/panel', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          applyBox.hidden = true;
          if (data.member) renderMember(data.member);
        })
        .catch(function () {
          applyBtn.disabled = false;
          applyBtn.textContent = 'Activate my referral link';
          toast('Something went wrong — try again');
        });
    });
  }

  function load() {
    var loading = $('[data-rrp-loading]');
    fetch(PROXY + '/panel', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (loading) loading.hidden = true;
        if (data.member) {
          renderMember(data.member);
        } else if (loggedIn) {
          var applyBox = $('[data-rrp-apply-box]');
          if (applyBox) {
            applyBox.hidden = false;
            bindApply(applyBox);
          }
        }
      })
      .catch(function () {
        if (loading) loading.hidden = true;
      });
  }

  if (loggedIn) {
    load();
  } else {
    var loading = $('[data-rrp-loading]');
    if (loading) loading.hidden = true;
  }
})();
